window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const handleFixCart = (element, cartSubject) => {
  if(element.length) {
    element.forEach((btn) => {
      btn.addEventListener('click', (e) => {
          setTimeout(() => {
            const id = setInterval(() => {
              const buttonAddToCarts = document.querySelectorAll('.product__popdown__cart');
              if (buttonAddToCarts.length) {
                handleFixCart(buttonAddToCarts, cartSubject);
                clearInterval(id);
              }
            }, 300);
            setTimeout(() => {clearInterval(id);}, 6000);

            cartSubject.notifyObserver('CartPriceMutate', 'ClickOpenMiniCart', {
                event: e,
             });
          }, 500)
      })
    })
  }
}
const customCartEvent = ({cartSubject}) => {
  const buttonAddToCarts = document.querySelectorAll('[bss-b2b-cart-trigger-added], .btn--add-to-cart');
  handleFixCart(buttonAddToCarts, cartSubject);
  console.log(cartSubject);
}
window.BSS_B2B.addAction('custom:cart/event', customCartEvent);
